"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = require("@antv/util");
var base_1 = require("./base");
var area_1 = require("./shape/area");
var split_data_1 = require("./util/split-data");
var Area = /** @class */ (function (_super) {
    tslib_1.__extends(Area, _super);
    function Area(cfg) {
        var _this = _super.call(this, tslib_1.__assign({ type: 'area', shapeType: 'area', generatePoints: true, sortable: true, connectNulls: false, showSinglePoint: false }, cfg)) || this;
        _this.set('shapeFactory', area_1.default);
        return _this;
    }
    Area.prototype.draw = function (data, container, shapeFactory, index) {
        var _this = this;
        var cfg = this.getDrawCfg(data[0]);
        var splitArray = split_data_1.splitData(data, this.get('connectNulls'), this.getYScale().field);
        cfg.origin = data; // path,line,area 等图的origin 是整个序列
        _.each(splitArray, function (subData, splitedIndex) {
            cfg.splitedIndex = splitedIndex; // 传入分割片段索引 用于生成id
            var points = subData.map(function (obj) {
                return obj.points;
            });
            cfg.points = points;
            var geomShape = shapeFactory.drawShape(cfg.shape, cfg, container);
            _this.appendShapeInfo(geomShape, index + splitedIndex);
        });
    };
    return Area;
}(base_1.default));
exports.default = Area;
//# sourceMappingURL=area.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/area.js
// module id = 800
// module chunks = 37